export { DeleteProduct as default } from './delete-product';
